import { render } from "./AssetMessagesPanel.vue?vue&type=template&id=735f76e7&scoped=true"
import script from "./AssetMessagesPanel.vue?vue&type=script&lang=js"
export * from "./AssetMessagesPanel.vue?vue&type=script&lang=js"

import "./AssetMessagesPanel.vue?vue&type=style&index=0&id=735f76e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735f76e7"]])

export default __exports__